import React, { useState, useEffect } from 'react';
import { USER_REQUEST_URL, getFetchRequest, postFetchRequest } from '../store/requests';
import {
    ERROR_WRONG_EMAIL_TYPE,
    ERROR_WRONG_ROLE_TYPE,
    LOCALE_RU,
    PERMISSION_LEVEL_COMPONENT,
} from '../constant';
import { Button, Input, Select } from '@chapche/ui';
import { useTranslation } from 'react-i18next';
import ProfilesTab from './users/ProfilesTab';
import PhoneInput from '../shared/PhoneInput';
import {errorCallback, makeUrl} from "../util";
import {rolesStorage} from "../services/rolesStorage";
import RolesTable from "./users/RolesTable";
import UsersTable from "./users/UsersTable";
import { useAuth } from '../auth/AuthContext';

const getRolesPermissions = () => {
    if (!rolesStorage.getRoles() || rolesStorage.getRoles().length === 0) {
        return [];
    }
    return rolesStorage.getRoles()[0].permissions.sort((a, b) => {
        if (a.level === PERMISSION_LEVEL_COMPONENT) { return -1; }
        if (b.level === PERMISSION_LEVEL_COMPONENT) { return 1; }
        if (a.title < b.title) { return -1; }
        if (a.title > b.title) { return 1; }
        return 0;
    }).map(it => {
        return {...it, isOpen: false};
    });
};

const getPossibleRoles = () => {
    return rolesStorage.getRoles().map(it => {
        return {id: it.id, code: it.code, name: it.name};
    });
};

const UsersPage = () => {
    const { user: currentUserData } = useAuth();
    const [inviteNewUserForm, setInviteNewUserForm] = useState({email: '', appRoleId:'', locale: LOCALE_RU});
    const [phoneInput, setPhoneInput] = useState('');
    const [usersList, setUsersList] = useState([]);
    const [error, setError] = useState({type:'', message:''});
    const [usersListModalIsOpen, setUsersListModalIsOpen] = useState(false);
    const [currentUserRole, setCurrentUserRole] = useState({});
    const [rolesPermissions, setRolesPermissions] = useState([]);
    const [possibleRoles, setPossibleRoles] = useState([]);
    const { i18n } = useTranslation();

    const refreshRolesUi = () => {
        setRolesPermissions(getRolesPermissions());
        setPossibleRoles(getPossibleRoles());
    };

    useEffect(() => {
        rolesStorage.registerRolesChangingObserver(refreshRolesUi);
        return () => rolesStorage.unRegisterRolesChangingObserver(refreshRolesUi);
    }, []);

    useEffect(() => {
        setCurrentUserRole(currentUserData?.appRole ?? {});
    }, [currentUserData?.appRole]);

    useEffect(() => {
        if (currentUserRole?.code) {
            getFetchRequest(makeUrl([USER_REQUEST_URL]), (response) => setUsersList(response || []), errorCallback);
            rolesStorage.loadItems();
        }
    }, [currentUserRole]);

    const handleChangeInviteNewUserFormEmail = (e) => {
        setInviteNewUserForm({...inviteNewUserForm, [e.target.name]: e.target.value});
    };

    const handleChangeInviteNewUserFormRole = (roleId) => {
        setInviteNewUserForm({...inviteNewUserForm, appRoleId: roleId});
    };

    const successCallbackInviteUser = (response) => {
        if(response.ok) {
            setInviteNewUserForm({email: '', appRoleId:'', locale: LOCALE_RU});
            setPhoneInput('');
            getFetchRequest(makeUrl([USER_REQUEST_URL]), (response) => setUsersList(response), errorCallback);
        }
    };

    const handleInviteUser = () => {
        if((inviteNewUserForm.email || phoneInput) && inviteNewUserForm.appRoleId ) {
            const preparedData = {
                appRoleId: inviteNewUserForm.appRoleId,
                locale: inviteNewUserForm.locale,
            };
            phoneInput ? preparedData.phone = `+7${phoneInput}` : preparedData.email = inviteNewUserForm.email;
            postFetchRequest(makeUrl([USER_REQUEST_URL]), preparedData, successCallbackInviteUser, errorCallback, true);
        } else {
            setError({type: inviteNewUserForm.email ? ERROR_WRONG_ROLE_TYPE : ERROR_WRONG_EMAIL_TYPE, message:''});
        }
    };

    return (
        <section className="workspace">
            {usersListModalIsOpen ? 
                <ProfilesTab
                    setUsersListModalIsOpen={setUsersListModalIsOpen}
                    usersList={usersList}
                    setUsersList={setUsersList}/>
                :
                <>
                    <h1 className="users__title block__title-h2">{i18n.t('app.page.user.title')}</h1>
                    <div className="users__wrapper">
                        <article className="users__article">
                            <h2 className="users__subtitle users__subtitle-send block__title-h3">{i18n.t('app.page.user.sendInvite')}</h2>
                            <form className="users__form">
                                <label className="block__text users__label" >
                                    <span className="product__form-label_text">{i18n.t('app.page.user.email')}</span>
                                    <Input
                                        fullWidth
                                        className="mt-0"
                                        name="email"
                                        value={inviteNewUserForm.email}
                                        onChange={handleChangeInviteNewUserFormEmail}
                                        state={error.type === ERROR_WRONG_EMAIL_TYPE ? 'error' : 'default'}
                                    />
                                </label>
                                <PhoneInput phone={phoneInput} setPhoneInput={setPhoneInput} error={error} />
                                <p className="block__text users__content">{i18n.t('app.page.user.selectRole')}</p>
                                <Select
                                    fullWidth
                                    className="mt-0"
                                    options={possibleRoles.map((role) => ({
                                        value: role.id,
                                        label: role.name,
                                    }))}
                                    value={inviteNewUserForm.appRoleId}
                                    onChange={handleChangeInviteNewUserFormRole}
                                />
                                <Button
                                    type="button"
                                    className="users__button"
                                    disabled={!((inviteNewUserForm.email || phoneInput) && inviteNewUserForm.appRoleId)}
                                    onClick={handleInviteUser}
                                >
                                    {i18n.t('app.page.user.send')}
                                </Button>
                            </form>
                        </article>
                        <article className="users__article users__article-list">
                            <h2 className="users__subtitle block__title-h3">{i18n.t('app.page.user.residentsData')}</h2>
                            <UsersTable usersList={usersList} isTab={false} />
                            <p className="block__table users__more navigation-link" onClick={() => setUsersListModalIsOpen(true)}>
                                {i18n.t('app.page.user.more')}
                            </p>
                        </article>
                    </div>
                    
                    <article className="users__article users__article_full-width">
                        <h2 className="users__subtitle block__title-h3">{i18n.t('app.page.user.roleAssignment')}</h2>
                        <RolesTable initialRolesPermissions={rolesPermissions}/>
                    </article>
                </>}
        </section>
    );
};

export default UsersPage;
